<script>
  import SendCardOverpanel from '../SendCardOverpanel/SendCardOverpanel.svelte';
  import { textCard } from '../../utils/send-card';
  import inputValidator from '../../utils/us-phone-format-validator';

  let {
    title,
    instructionLabelText,
    inputPlaceholder,
    inputValidationMessage,
    disclaimer,
    submitButtonText,
    successMessage,
    closeButtonText,
    errorMessage,
    errorInstruction,
    unsubscribedErrorMessage,
    unsubscribedErrorInstruction,
    retryButtonText,
    newsletterSignup,
    card = {},
    query = {},
    lang,
  } = $props();
  const textCardOverpanel = true;
</script>

<SendCardOverpanel
  {title}
  {instructionLabelText}
  {inputValidator}
  {inputPlaceholder}
  {inputValidationMessage}
  {disclaimer}
  {submitButtonText}
  {successMessage}
  {closeButtonText}
  {errorMessage}
  {card}
  {query}
  {lang}
  {errorInstruction}
  {retryButtonText}
  {unsubscribedErrorMessage}
  {unsubscribedErrorInstruction}
  {newsletterSignup}
  {textCardOverpanel}
  overpanelKey="textCard"
  inputType="tel"
  inputPattern={'[0-9]{3}-[0-9]{3}-[0-9]{4}'}
  sendCardService={textCard}
  successIconName="phone"
  data-testid="text-card-overpanel"
/>
